import { useSelector, useDispatch } from 'react-redux'
import {
  selectCountry,
  selectCurrency,
  selectLanguage,
  setLanguage as setLocaleLanguage,
  setCountry as setLocaleCountry,
  setCurrency as setLocaleCurrency,
} from '../store/localeSlice'

const useLocale = () => {
  const dispatch = useDispatch()
  const country = useSelector(selectCountry)
  const currency = useSelector(selectCurrency)
  const language = useSelector(selectLanguage)

  function setCurrency(...args) {
    dispatch(setLocaleCurrency(...args))
  }

  function setCountry(...args) {
    dispatch(setLocaleCountry(...args))
  }

  function setLanguage(...args) {
    dispatch(setLocaleLanguage(...args))
  }

  return {
    country,
    currency,
    language,
    setCountry,
    setCurrency,
    setLanguage,
  }
}

export default useLocale
